import React, {useEffect, useRef, useState} from "react";
import {Alert, Button, Input} from "reactstrap";
import ModalAkitatek from "../../../../components/Akitatek/Modal/Modal";
import {estManettePlayStation, nomAppareil, numeroManetteDepuis} from "../../../../util/assistantPec";

const URL_OUTIL = process.env.PUBLIC_URL + "/calibration/index.html";

/**
 * Lecture du numéro de série d'une manette PS4 / PS5 avec l'outil de calibration (même origine, dans une iframe) :
 * l'outil note la dernière manette branchée dans le localStorage, qu'on surveille tant que la fenêtre est ouverte.
 */
function LectureManette({ouvert, onLu, onFermer}) {
    const [depuis, setDepuis] = useState(0);
    const [lu, setLu] = useState(null);

    useEffect(() => {
        if (!ouvert) {
            return undefined;
        }
        const debut = Date.now() - 1000;
        setDepuis(debut);
        setLu(null);
        const minuteur = setInterval(() => {
            const trouve = numeroManetteDepuis(window.localStorage, debut);
            if (trouve) {
                setLu(trouve);
            }
        }, 700);
        return () => clearInterval(minuteur);
    }, [ouvert]);

    const webHid = typeof navigator !== "undefined" && !!navigator.hid;

    return (
        <ModalAkitatek show={ouvert} title="Lire le numéro de série de la manette" onCallback={onFermer}>
            {!webHid && (
                <Alert color="warning">
                    Ce navigateur ne sait pas parler aux manettes. Ouvrez le tableau de bord avec Chrome, Edge ou Opera.
                </Alert>
            )}
            {lu ? (
                <Alert color="success" className="d-flex justify-content-between align-items-center">
                    <span>Numéro lu : <strong>{lu.serial}</strong>{lu.modele ? ` (${lu.modele})` : ""}</span>
                    <Button color="success" onClick={() => onLu(lu.serial)}>Utiliser ce numéro</Button>
                </Alert>
            ) : (
                <p className="text-muted mb-2">
                    Branchez la manette en USB puis cliquez sur « Connecter » ci-dessous : le numéro apparaîtra ici tout seul.
                </p>
            )}
            {ouvert && depuis > 0 && (
                <iframe title="Outil de calibration" src={URL_OUTIL} allow="hid"
                        style={{width: "100%", height: "60vh", border: 0}}/>
            )}
        </ModalAkitatek>
    );
}

/** Étape 4 : le numéro de série, scanné, tapé, ou lu sur la manette avec l'outil de calibration. */
export default function EtapeSerie({ligne, onChange}) {
    const [lecture, setLecture] = useState(false);
    const champ = useRef(null);
    const manette = estManettePlayStation(ligne.appareil);

    useEffect(() => {
        if (champ.current) {
            champ.current.focus();
        }
    }, []);

    return (
        <div>
            <h4>Numéro de série de {nomAppareil(ligne.appareil)}</h4>
            {manette && (
                <div className="assistant-pec-manette mb-3">
                    <div>
                        <strong>Manette PlayStation :</strong> branchez-la en USB, l'outil de calibration lit son numéro.
                    </div>
                    <Button color="primary" onClick={() => setLecture(true)}>
                        <i className="fa fa-gamepad mr-2"/>Lire la manette
                    </Button>
                </div>
            )}
            <Input innerRef={champ} bsSize="lg" placeholder="Scannez ou tapez le numéro (facultatif)"
                   value={ligne.serial} onChange={e => onChange({serial: e.target.value})}/>
            {!manette && (
                <Button color="link" className="px-0 mt-2" onClick={() => setLecture(true)}>
                    <i className="fa fa-gamepad mr-1"/>Lire une manette PS4 / PS5 avec l'outil de calibration
                </Button>
            )}
            <LectureManette ouvert={lecture}
                            onFermer={() => setLecture(false)}
                            onLu={(serial) => {
                                onChange({serial});
                                setLecture(false);
                            }}/>
        </div>
    );
}
